const Price = ({price}: IPrice) => {
  return (
    <>
      <div className=" mt-7 flex justify-between">
        <p className=" text-gray-6">قیمت:</p>
        <p className=" text-gray-6">{price}</p>
      </div>
    </>
  );
};

export default Price;
